export default __webpack_public_path__ + "static/crafting-c8612bb19e3184c46849d3979cf05939.webp";